import { render, staticRenderFns } from "./ChatsOverview.vue?vue&type=template&id=39b88604&"
import script from "./ChatsOverview.vue?vue&type=script&lang=js&"
export * from "./ChatsOverview.vue?vue&type=script&lang=js&"
import style0 from "./ChatsOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports